import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Authentication
export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API}/auth/login`, { username, password });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de connexion' };
  }
};

export const logout = async () => {
  try {
    const response = await axios.post(`${API}/auth/logout`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de déconnexion' };
  }
};

// Clients
export const getAllClients = async () => {
  try {
    const response = await axios.get(`${API}/clients`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de récupération des clients' };
  }
};

export const getClient = async (clientId) => {
  try {
    const response = await axios.get(`${API}/clients/${clientId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de récupération du client' };
  }
};

export const createClient = async (clientData) => {
  try {
    const response = await axios.post(`${API}/clients`, clientData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de création du client' };
  }
};

export const updateClient = async (clientId, clientData) => {
  try {
    const response = await axios.put(`${API}/clients/${clientId}`, clientData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de mise à jour du client' };
  }
};

export const deleteClient = async (clientId) => {
  try {
    const response = await axios.delete(`${API}/clients/${clientId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de suppression du client' };
  }
};

export const getMyClientData = async (username) => {
  try {
    const response = await axios.get(`${API}/clients/me/data?username=${username}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de récupération des données' };
  }
};

// Update client password
export const updateClientPassword = async (clientId, newPassword) => {
  try {
    const response = await axios.put(`${API}/clients/${clientId}/password`, { password: newPassword });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de mise à jour du mot de passe' };
  }
};

// Update admin password
export const updateAdminPassword = async (newPassword) => {
  try {
    const response = await axios.put(`${API}/auth/admin/password`, { password: newPassword });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de mise à jour du mot de passe admin' };
  }
};

// Documents
export const uploadDocument = async (clientId, fileName, fileType) => {
  try {
    const response = await axios.post(`${API}/clients/${clientId}/documents?file_name=${fileName}&file_type=${fileType}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur d\'upload du document' };
  }
};

export const deleteDocument = async (clientId, documentId) => {
  try {
    const response = await axios.delete(`${API}/clients/${clientId}/documents/${documentId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de suppression du document' };
  }
};

// File upload/download
export const uploadFile = async (clientId, documentId, fileData) => {
  try {
    const response = await axios.post(`${API}/clients/${clientId}/documents/${documentId}/file`, fileData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur d\'upload du fichier' };
  }
};

export const downloadFile = async (clientId, documentId) => {
  try {
    const response = await axios.get(`${API}/clients/${clientId}/documents/${documentId}/file`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de téléchargement du fichier' };
  }
};

// Banking features
export const updateAccounts = async (clientId, accounts) => {
  try {
    const response = await axios.put(`${API}/clients/${clientId}/accounts`, accounts);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de mise à jour des comptes' };
  }
};

export const addBeneficiary = async (clientId, beneficiary) => {
  try {
    const response = await axios.post(`${API}/clients/${clientId}/beneficiaries`, beneficiary);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur d\'ajout du bénéficiaire' };
  }
};

export const deleteBeneficiary = async (clientId, beneficiaryId) => {
  try {
    const response = await axios.delete(`${API}/clients/${clientId}/beneficiaries/${beneficiaryId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de suppression du bénéficiaire' };
  }
};

export const updateRIB = async (clientId, rib) => {
  try {
    const response = await axios.put(`${API}/clients/${clientId}/rib`, rib);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de mise à jour du RIB' };
  }
};

export const updateContact = async (clientId, contact) => {
  try {
    const response = await axios.put(`${API}/clients/${clientId}/contact`, contact);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de mise à jour du contact' };
  }
};

// Upload Offer PDF
export const uploadOfferPdf = async (clientId, data) => {
  try {
    const response = await axios.post(`${API}/clients/${clientId}/offer-pdf`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur lors de l\'upload de l\'offre' };
  }
};

// Download Offer PDF
export const downloadOfferPdf = async (clientId) => {
  try {
    const response = await axios.get(`${API}/clients/${clientId}/offer-pdf`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de téléchargement de l\'offre' };
  }
};

// Delete Offer PDF
export const deleteOfferPdf = async (clientId) => {
  try {
    const response = await axios.delete(`${API}/clients/${clientId}/offer-pdf`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur lors de la suppression de l\'offre' };
  }
};

// Messages API
export const sendMessage = async (clientId, messageData) => {
  try {
    const response = await axios.post(`${API}/clients/${clientId}/messages`, messageData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur lors de l\'envoi du message' };
  }
};

export const getAllMessages = async () => {
  try {
    const response = await axios.get(`${API}/messages`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de récupération des messages' };
  }
};

export const getUnreadMessagesCount = async () => {
  try {
    const response = await axios.get(`${API}/messages/unread-count`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur' };
  }
};

export const markMessageRead = async (messageId) => {
  try {
    const response = await axios.put(`${API}/messages/${messageId}/read`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur' };
  }
};

export const replyToMessage = async (messageId, reply) => {
  try {
    const response = await axios.put(`${API}/messages/${messageId}/reply`, { reply });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur lors de la réponse' };
  }
};

export const deleteMessage = async (messageId) => {
  try {
    const response = await axios.delete(`${API}/messages/${messageId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Erreur de suppression' };
  }
};
